import React, { useState } from "react";
import { X, Loader2, Video, Type, User, FileText } from "lucide-react";
import { createVideoReviewAPI } from "../services/apicollection";

const MAX_VIDEO_SIZE = 5 * 1024 * 1024; // 5MB
const ALLOWED_VIDEO_TYPES = ["video/mp4", "video/webm", "video/ogg", "video/quicktime"];

const courseOptions = [
  "MERN Stack Course",
  "Digital marketing",
  "Data analytics",
  "Data science",
  "Frontend web development",
  "Backend development",
  "Web development",
  "Python",
];

const Stars = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
  >
    <g clipPath="url(#clip0_stars)">
      <path
        d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
        fill="#FFA40B"
      />
      <path
        d="M15.043 25.8299C15.0984 25.8236 15.1537 25.817 15.209 25.8099C15.6361 25.7361 16.0593 25.641 16.477 25.5249C16.8949 25.4096 17.3067 25.2734 17.711 25.1169C18.1146 24.9598 18.5101 24.7826 18.896 24.5859C19.2822 24.3892 19.6583 24.1733 20.023 23.9389C20.3877 23.705 20.7405 23.4531 21.08 23.1839C21.4198 22.9144 21.7458 22.6281 22.057 22.3259C22.368 22.0239 22.6637 21.7065 22.943 21.3749C23.2221 21.0433 23.4844 20.6978 23.729 20.3399C23.974 19.9822 24.2009 19.6124 24.409 19.2319C24.617 18.8516 24.8059 18.4611 24.975 18.0619C25.1213 17.7099 25.2521 17.3515 25.367 16.9879L19.877 11.4979C19.792 11.4679 19.72 11.4379 19.59 11.4059C19.198 11.3099 18.65 11.2239 18.086 11.1449L17.666 11.0849L13.041 6.46094C12.986 6.53094 12.934 6.59194 12.863 6.70494C12.65 7.04694 12.399 7.54094 12.15 8.05094C11.902 8.56094 11.654 9.08794 11.43 9.52294C11.3299 9.72047 11.2215 9.91365 11.105 10.1019C11.001 10.2669 10.927 10.3999 10.736 10.5349C10.546 10.6709 10.394 10.6989 10.203 10.7449C10.013 10.7879 9.79299 10.8259 9.55099 10.8609C9.06499 10.9319 8.48399 10.9949 7.91999 11.0639C7.35499 11.1339 6.80499 11.2109 6.41199 11.3009C6.28199 11.3309 6.20899 11.3599 6.12299 11.3889C6.17299 11.4639 6.21499 11.5309 6.30099 11.6329C6.46099 11.8219 6.67099 12.0429 6.90399 12.2749L9.07599 14.4469C9.16399 14.5559 9.24299 14.6629 9.29599 14.8339C9.36699 15.0559 9.34799 15.2079 9.33199 15.4019C9.31133 15.6215 9.2813 15.84 9.24199 16.0569C9.15899 16.5389 9.03799 17.1089 8.92999 17.6659C8.82644 18.1632 8.74635 18.6651 8.68999 19.1699C8.67799 19.3029 8.68199 19.3799 8.68399 19.4699L15.043 25.8299Z"
        fill="#FF7712"
      />
      <path
        d="M13.0391 6.45703C13.0925 6.5289 13.1438 6.59009 13.2121 6.70468C13.4204 7.04945 13.6639 7.54769 13.9042 8.06144C14.1445 8.57616 14.3826 9.10736 14.6005 9.5473C14.7094 9.76581 14.8119 9.96199 14.9144 10.129C15.0159 10.2961 15.0896 10.4301 15.2775 10.569C15.4655 10.7079 15.6161 10.738 15.8062 10.7865C15.9963 10.8341 16.2141 10.8739 16.4566 10.9137C16.9414 10.9924 17.5213 11.0643 18.0841 11.142C18.648 11.2207 19.1959 11.3071 19.5878 11.4023C19.7181 11.4343 19.7907 11.4644 19.8761 11.4945C19.8238 11.5683 19.7811 11.6353 19.6946 11.7353C19.4287 12.0393 19.0293 12.4249 18.6128 12.8104C18.1963 13.1979 17.7637 13.5883 17.4124 13.9302C17.2362 14.1011 17.0813 14.2604 16.9532 14.408C16.8261 14.5556 16.7203 14.6673 16.6467 14.8887C16.5719 15.1092 16.5901 15.2616 16.6029 15.4568C16.6157 15.6511 16.6445 15.8706 16.6819 16.1134C16.7567 16.597 16.8677 17.169 16.967 17.7274C17.0664 18.2859 17.1539 18.8326 17.1838 19.2347C17.1934 19.3668 17.187 19.4455 17.1838 19.5358C17.0984 19.5096 17.0204 19.4891 16.8976 19.4377C16.527 19.2803 16.0358 19.02 15.5392 18.7452C15.0415 18.4694 14.5353 18.1801 14.0996 17.9519C13.9054 17.848 13.7062 17.752 13.5026 17.6644C13.3221 17.5896 13.1833 17.5236 12.9494 17.5216C12.7155 17.5216 12.5756 17.5837 12.3941 17.6556C12.2125 17.7284 12.0118 17.8236 11.7928 17.9334C11.355 18.1538 10.8423 18.4364 10.3404 18.7035C9.83847 18.9705 9.34508 19.2221 8.9713 19.3736C8.84742 19.4241 8.77053 19.4425 8.68296 19.4678C8.68189 19.3774 8.67655 19.2988 8.68829 19.1668C8.7246 18.7657 8.82072 18.2199 8.92965 17.6634C9.03751 17.1069 9.15819 16.5368 9.24042 16.0541C9.27969 15.8367 9.30961 15.6181 9.33013 15.3986C9.34615 15.2044 9.36644 15.0519 9.29596 14.8295C9.22547 14.6071 9.12188 14.4945 8.99693 14.3439C8.85393 14.1767 8.70321 14.015 8.54518 13.8593C8.20024 13.5116 7.77306 13.1144 7.36297 12.7211C6.99032 12.3721 6.63573 12.0075 6.30036 11.6285C6.21385 11.5266 6.1722 11.4596 6.12201 11.3848C6.20745 11.3556 6.28113 11.3265 6.41035 11.2964C6.80443 11.2061 7.35442 11.1293 7.91937 11.0604C8.48325 10.9914 9.06421 10.9293 9.55013 10.8584C9.79362 10.8235 10.0126 10.7855 10.2026 10.7409C10.3927 10.6962 10.5444 10.6681 10.7345 10.5321C10.9246 10.3961 11.0015 10.2631 11.1051 10.098C11.2097 9.93287 11.3155 9.73864 11.4276 9.5211C11.6519 9.08505 11.8996 8.5577 12.1484 8.04686C12.3643 7.58913 12.6023 7.14032 12.8618 6.70178C12.9323 6.58815 12.9836 6.52793 13.0391 6.45703Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_stars">
        <rect width="26" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const VideoReviewForm = ({ onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    name: "",
    course: courseOptions[0],
    message: "",
    rating: 5,
  });
  const [videoFile, setVideoFile] = useState(null);
  const [videoError, setVideoError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleVideoChange = (e) => {
    const file = e.target.files?.[0];
    setVideoError("");
    setVideoFile(null);

    if (!file) return;

    if (!ALLOWED_VIDEO_TYPES.includes(file.type)) {
      setVideoError("Only MP4, WebM, OGG, or MOV videos are allowed");
      return;
    }

    if (file.size > MAX_VIDEO_SIZE) {
      setVideoError("Video size must not exceed 5MB");
      return;
    }

    setVideoFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name?.trim()) {
      alert("Student name is required");
      return;
    }

    if (!videoFile) {
      alert("Please select a video file (max 5MB)");
      return;
    }

    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("name", formData.name.trim());
      fd.append("course", formData.course);
      fd.append("message", formData.message?.trim() || "");
      fd.append("rating", formData.rating);
      fd.append("videoreview", videoFile);

      const res = await createVideoReviewAPI(fd);
      if (!res?.status) {
        alert(res?.message || "Failed to create video review");
      } else if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      alert(
        error.response?.data?.message ||
          error.message ||
          "Failed to create video review"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl rounded-xl border border-[#1d3350] bg-[#0f1c2e] p-4 shadow-sm sm:p-6">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <h2 className="text-base font-semibold text-slate-200">
            Add Video Review
          </h2>
          <p className="mt-0.5 text-xs text-slate-500">
            Upload a student video testimonial. Maximum file size: 5MB.
          </p>
        </div>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="flex h-8 w-8 items-center justify-center rounded-full bg-[#13233a] text-slate-500 hover:bg-slate-200"
          >
            <X size={16} />
          </button>
        )}
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-slate-400">
            Student Name <span className="text-red-500">*</span>
          </label>
          <div className="mt-1 flex items-center gap-2 rounded-lg border border-[#1d3350] px-3 py-2 text-sm focus-within:border-slate-500 focus-within:ring-1 focus-within:ring-slate-500">
            <User size={16} className="text-slate-400 shrink-0" />
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              className="h-7 w-full border-none bg-transparent text-sm outline-none"
              placeholder="e.g. John Doe"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400">
            Course
          </label>
          <div className="mt-1 flex items-center gap-2 rounded-lg border border-[#1d3350] px-3 py-2 text-sm focus-within:border-slate-500 focus-within:ring-1 focus-within:ring-slate-500">
            <Type size={16} className="text-slate-400 shrink-0" />
            <select
              value={formData.course}
              onChange={(e) => handleChange("course", e.target.value)}
              className="h-7 w-full border-none bg-transparent text-sm outline-none capitalize"
            >
              {courseOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400">
            Rating
          </label>
          <div className="mt-1 flex items-center gap-0.5">
            {[1, 2, 3, 4, 5].map((i) => (
              <button
                key={i}
                type="button"
                onClick={() => handleChange("rating", i)}
                className="p-0.5 transition-opacity hover:opacity-80"
              >
                <span className={i <= formData.rating ? "opacity-100" : "opacity-20"}>
                  <Stars size={24} />
                </span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400">
            Video File <span className="text-red-500">*</span> (max 5MB)
          </label>
          <div className="mt-1 flex items-center gap-2 rounded-lg border border-[#1d3350] px-3 py-2 text-sm focus-within:border-slate-500 focus-within:ring-1 focus-within:ring-slate-500">
            <Video size={16} className="text-slate-400 shrink-0" />
            <input
              type="file"
              accept="video/mp4,video/webm,video/ogg,video/quicktime"
              onChange={handleVideoChange}
              className="w-full text-sm file:mr-2 file:rounded-lg file:border-0 file:bg-[#13233a] file:px-3 file:py-1 file:text-slate-300 file:hover:bg-slate-200"
            />
          </div>
          {videoFile && (
            <p className="mt-1 text-xs text-emerald-600">
              Selected: {videoFile.name} ({(videoFile.size / 1024).toFixed(1)} KB)
            </p>
          )}
          {videoError && (
            <p className="mt-1 text-xs text-red-600">{videoError}</p>
          )}
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400">
            Message (optional)
          </label>
          <div className="mt-1 flex items-start gap-2 rounded-lg border border-[#1d3350] px-3 py-2 text-sm focus-within:border-slate-500 focus-within:ring-1 focus-within:ring-slate-500">
            <FileText size={16} className="mt-0.5 shrink-0 text-slate-400" />
            <textarea
              value={formData.message}
              onChange={(e) => handleChange("message", e.target.value)}
              rows={3}
              className="w-full flex-1 resize-none border-none bg-transparent text-sm outline-none"
              placeholder="Brief testimonial message..."
            />
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2">
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="rounded-lg border border-[#1d3350] px-3 py-1.5 text-sm font-medium text-slate-300 hover:bg-[#0d1b2e]"
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="inline-flex items-center gap-2 rounded-lg bg-slate-800 px-4 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-700 disabled:opacity-60"
          >
            {submitting && <Loader2 size={16} className="animate-spin" />}
            Add Video Review
          </button>
        </div>
      </form>
    </div>
  );
};

export default VideoReviewForm;
